<div class="navbar-header">
    <div class="logo logo-margin">
        <img width="200" height="200" style="cursor: pointer" [routerLink]="['webhome']" class="logo-icon"
            src="../../../../../assets/images/sendo/MarcaBlanco.png" />
    </div>

    <button mat-button class="toggle-button-navbar mat-icon-button" wtfNavbarVertical="toggleFold" fxHide.lt-lg>
        <mat-icon class="icon-size">menu</mat-icon>
    </button>

    <button mat-button class="toggle-button-navbar mat-icon-button" wtfNavbarVertical="closeBar" fxHide.gt-md>
        <mat-icon class="icon-size">arrow_back</mat-icon>
    </button>
</div>

<div class="navbar-content" wtfPerfectScrollbar>
    <wtf-navigation layout="vertical"></wtf-navigation>
</div>